/**
 * Locks the page while Shopify's customer privacy banner is showing, so the
 * visitor cannot browse on until they accept, decline or set preferences.
 * The banner is injected asynchronously, hence the observer.
 */
(function () {
  const BANNER_ID = 'shopify-pc__banner';
  const PREFS_ID = 'shopify-pc__prefs';
  const LOCK_CLASS = 'cookie-banner-open';

  // offsetParent is null for position: fixed elements, so check computed styles.
  function isVisible(el) {
    if (!el || !el.isConnected) return false;
    const styles = getComputedStyle(el);
    return styles.display !== 'none' && styles.visibility !== 'hidden' && el.getClientRects().length > 0;
  }

  function sync() {
    const open = isVisible(document.getElementById(BANNER_ID)) || isVisible(document.getElementById(PREFS_ID));
    document.body.classList.toggle(LOCK_CLASS, open);
  }

  function init() {
    sync();
    new MutationObserver(sync).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'hidden'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
